var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/image/akc/1.jpg": "601e",
	"./assets/image/akc/2.jpg": "82c6",
	"./assets/image/akc/global.png": "e0db",
	"./assets/image/akc_wholesale/1.jpg": "665f",
	"./assets/image/akc_wholesale/2.jpg": "5401",
	"./assets/image/akc_wholesale/3.jpg": "5315",
	"./assets/image/akc_wholesale/4.jpg": "6c05",
	"./assets/image/guide.png": "e28c",
	"./assets/image/logo.png": "a1d8",
	"./assets/image/x/global.png": "b686",
	"./assets/image/x/header.png": "a5ee",
	"./assets/image/x/select.png": "bf36",
	"./assets/image/xpp-bg.png": "3d81",
	"./assets/js/track": "e1b1",
	"./assets/js/track.js": "e1b1",
	"./assets/js/util": "bbd5",
	"./assets/js/util.js": "bbd5",
	"./main": "56d7",
	"./main.js": "56d7",
	"./main.vue": "1dae",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./views/akc_liaoyuan": "e3c5",
	"./views/akc_liaoyuan.vue": "e3c5",
	"./views/akc_wholesale": "9956",
	"./views/akc_wholesale.vue": "9956",
	"./views/akc_xiubin": "0aab",
	"./views/akc_xiubin.vue": "0aab",
	"./views/akc_xuanlu": "0c4c",
	"./views/akc_xuanlu.vue": "0c4c",
	"./views/akc_yuhua": "575d",
	"./views/akc_yuhua.vue": "575d",
	"./views/xpp": "6a19",
	"./views/xpp.vue": "6a19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35a6";